export default function initModal() {
  document.querySelectorAll('[data-modal]').forEach(opener => {
    const body = document.querySelector('body');
    const modal = document.querySelector(opener.dataset.modal);
    const closers = modal.querySelectorAll('[data-close]');
    const showClass = 'opened';
    const showModalClass = 'modal-opened';

    const showModal = e => {
      e.preventDefault();
      modal.classList.add(showClass);
      body.classList.add(showModalClass);
    }
    const closeModal = e => {
      e.preventDefault();
      modal.classList.remove(showClass);
      body.classList.remove(showModalClass);
    }

    opener.addEventListener('click', showModal);
    closers.forEach(closeBtn => {
      closeBtn.addEventListener('click', closeModal);
    })
  });
}
